"use client";

import { cn } from "@/lib/utils";
import Link from "@components/Link";
import useTracking from "@features/tracking/hooks/useTracking";
import type { ReactNode } from "react";
import { forwardRef, useCallback, useContext } from "react";
import { ProductCardContext } from "./ProductCardContext";

type ProductCardLinkProps = {
  className?: string;
  children?: ReactNode;
};

const ProductCardLink = forwardRef<HTMLAnchorElement, ProductCardLinkProps>(
  ({ className, children, ...props }, ref) => {
    const { legacyTrackProduct } = useTracking();
    const { product, locale, market } = useContext(ProductCardContext);

    const trackSelectListItemEvent = useCallback(() => {
      if (
        legacyTrackProduct === undefined ||
        product === undefined ||
        market?.currency === undefined
      ) {
        return;
      }

      legacyTrackProduct(product);
    }, [market?.currency, product, legacyTrackProduct]);

    if (!product) return null;

    return (
      <Link
        ref={ref}
        locale={locale}
        href={product.ProductURL ?? ""}
        className={cn("block bg-white", className)}
        onClick={() => {
          trackSelectListItemEvent();
        }}
        customPrefetch="onMouseEnter"
        {...props}
      >
        {children}
      </Link>
    );
  },
);

ProductCardLink.displayName = "ProductCardLink";

export default ProductCardLink;
